export default {
  label: {
    en: 'off',
  },
  title: {
    en: 'Take {discount, select, 25 {quarter} 50 {half} other {#%}} off your first month',
  },
  subTitle: {
    en: 'for all plans',
  },
  text: {
    en: 'Choose the amount of fragrances you’d like to receive each month. The more you get, the more you save.',
  },
}
